// Firebase設定ファイル
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, connectAuthEmulator } from 'firebase/auth';
import { getStorage } from "firebase/storage";

const env = import.meta.env;

// 環境に応じたFirebase設定を取得
const getFirebaseConfig = () => {
  // 開発環境でエミュレーターを使用する場合
  if (process.env.NODE_ENV === 'development' && env.VITE_FIREBASE_USE_EMULATOR === 'true') {
    return {
      apiKey: "firebase-emulator-api-key",
      authDomain: "localhost",
      projectId: "demo-fammy-development",
      storageBucket: "demo-fammy-development.appspot.com",
      messagingSenderId: "000000000000",
      appId: "1:000000000000:web:0000000000000000000000"
    };
  }

  // 本番、ステージングでは環境変数を利用
  return {
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: env.VITE_FIREBASE_APP_ID
  };
};

// 設定を取得
const firebaseConfig = getFirebaseConfig();

const app = initializeApp(firebaseConfig, {});

// 認証を初期化
const auth = getAuth(app);
const storage = getStorage(app);

// 開発環境の場合、Firebaseエミュレーターに接続
if (process.env.NODE_ENV === 'development' && env.VITE_FIREBASE_USE_EMULATOR === 'true') {
  // ブラウザから接続するため、localhost:9099に変更
  // disableWarnings: 画面とコンソールに出るエミュレータ使用の警告を非表示
  connectAuthEmulator(auth, 'http://localhost:9099', {
    disableWarnings: true
  });
}

// 認証の永続性を設定（ブラウザを閉じても認証状態を保持）
setPersistence(auth, browserLocalPersistence)

export { app, auth, storage, firebaseConfig };